import * as actions from 'app/actions/token';
import http from 'app/services/http';

export const tokenReducer = (
    state = {
        items: [],
        searchValue: '',
        selectedItem: null,
    },
    action
) => {
    switch (action.type) {
        case 'TOKEN_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: items,
            };
        }
        case 'TOKEN_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
            };
        }
        case 'TOKEN_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                searchValue: value,
            };
        }
        case 'TOKEN_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: [...state.items, data],
            };
        }
        case 'TOKEN_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
                items: state.items.map((item) => (item.id !== state.selectedItem.id ? item : data)),
            };
        }
        default:
            return state;
    }
};

export function tokenLoad() {
    return async function tokenLoadThunk(dispatch) {
        const { data } = await http.get('/token');
        return dispatch(actions.setItems(data));
    };
}

export function tokenCreate(params) {
    return async function tokenCreateThunk(dispatch) {
        const { data } = await http.post('/token', params);
        return dispatch(actions.addItem(data));
    };
}

export function tokenUpdate(id, updateData) {
    return async function tokenUpdateThunk(dispatch) {
        const { data } = await http.put(`/token/${id}`, updateData);
        return dispatch(actions.updateItem(data));
    };
}

export default tokenReducer;
